import { startsWith } from 'lodash';

import type { RouteParams } from '@common/defaults/RouteParams';

/*
 * Removes the leading slash from a URL if it exists.
 * @param url The URL to clean.
 * @returns The cleaned URL without a leading slash.
 */
export const cleanLeadingSlash = (url: string = ''): string =>
    startsWith(url, '/') ? url.substring(1) : url;

export const stripSegments = (pathname: string, count: number): string =>
    `/${pathname
        .split('/')
        .slice(count + 1)
        .join('/')}`;

export const getSingularRouteParam = (params: RouteParams, key: string): string | undefined =>
    Array.isArray(params[key]) ? params[key]?.at(-1) : params[key];
